import { useEffect } from 'react';

const Footer = () => {
    return (
        <div id="vz-gf20"></div>
    );
};

export default Footer;
